module.exports = __webpack_public_path__ + "static/Thumbnail_StudioMidos-6809c66ef953c76dd6e7e4fcb0a1ea25.png";